export default Object.freeze({
  officePhotos: {
    max: 10,
  },
});
